import type { HelpLink, PageHelpContent } from './helpTypes';

/**
 * Plantilla estándar de guía (5 bloques) para mantener consistencia en todas las pantallas.
 */
export function hp(
  title: string,
  intro: string,
  d: {
    queHace?: string;
    pasos: string[];
    campos?: string[];
    errores?: string[];
    tips?: string[];
    links?: HelpLink[];
  }
): PageHelpContent {
  return {
    title,
    intro,
    sections: [
      {
        id: 'que-hace',
        title: 'Qué hace esta pantalla',
        body:
          d.queHace ??
          `Permite trabajar con ${title}: consultar, cargar y mantener datos según tus permisos y la parametrización del sistema.`,
      },
      { id: 'pasos', title: 'Pasos recomendados', bullets: d.pasos },
      ...(d.campos?.length
        ? [{ id: 'campos', title: 'Campos y conceptos clave', bullets: d.campos }]
        : []),
      ...(d.errores?.length
        ? [{ id: 'errores', title: 'Errores frecuentes', bullets: d.errores }]
        : []),
      {
        id: 'tips',
        title: 'Tips',
        bullets:
          d.tips ?? [
            'Si la pantalla tiene filtros, aplicá uno a la vez para ubicar más rápido el dato.',
            'Antes de salir, confirmá si hay botón Guardar o el sistema persiste solo al confirmar.',
          ],
      },
    ],
    links: d.links,
  };
}
